import { axios } from '@/utils/request'

const api = {
  userList: '/badminapi/user/userlist',
  userDetail: '/badminapi/user/userdetail',
  userEdit: '/badminapi/user/useredit',
  userGroupList: '/badminapi/user/userGroupList',
  setPassword: '/badminapi/user/setPassword',
  editUserWeixin: '/badminapi/user/editUserWeixin',
  userOptions: '/badminapi/user/userOptions',
  editPassword: '/badminapi/user/editPassword',
}

export default api

export function getUserList(parameter) {
  return axios({
    url: api.userList,
    method: 'get',
    params: parameter
  })
}
export function getUserDetail(parameter) {
  return axios({
    url: api.userDetail,
    method: 'get',
    params: parameter
  })
}

export function editUser(parameter) {
  return axios({
    url: api.userEdit,
    method: 'post',
    data: parameter
  })
}


export function editUserWeixin(parameter) {
  return axios({
    url: api.editUserWeixin,
    method: 'post',
    data: parameter
  })
}

export function editPassword(parameter) {
  return axios({
    url: api.editPassword,
    method: 'post',
    data: parameter
  })
}

export function getUserGroupList(parameter) {
  return axios({
    url: api.userGroupList,
    method: 'get',
    params: parameter
  })
}
export function setPassword(parameter) {
  return axios({
    url: api.setPassword,
    method: 'get',
    params: parameter
  })
}


export function getUserOptions(parameter) {
  return axios({
    url: api.userOptions,
    method: 'get',
    params: parameter
  })
}

